import { useLocation } from 'react-router-dom'
import '../css/Error.css'
import { imgURL } from './Home'
import { useAppContext } from '../components/provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../js/postMessage'

export default function Error() {
  const location = useLocation()
  // const navigate = useNavigate()
  const { isAppView } = useAppContext()

  // const errorMessage = location.state?.error || 'Unknown error occurred'
  // location.state가 없을 때도 안전하게 처리
  const errorObj = location.state?.error
  const errorMessage =
    errorObj?.message || errorObj?.statusText || (typeof errorObj === 'string' ? errorObj : 'Unknown error occurred')
  const is404 = errorObj?.status === 404

  return (
    <>
      <div className='error'>
        <div className='inner'>
          <img src={`${imgURL}/error_empty.png`} alt='' />
          <div className='txt_inner'>
            <p>
              {is404 ? (
                '페이지를 찾을 수 없습니다.'
              ) : (
                <>
                  장애가 발생되었습니다.
                  <br />
                  잠시 후 다시 시도해주세요.
                </>
              )}
            </p>
            <span>오류 내용 : {errorMessage}</span>
          </div>
        </div>
        <div
          className='errorButton'
          onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.goBack)
            } else {
              // navigate('/')
              window.location.replace('/')
            }
          }}
        >
          홈으로 가기
        </div>
      </div>
    </>
  )
}
